import Vue from 'vue';
import Router from 'vue-router';
import setting from '@/config/setting'
import {
	BasicLayout
} from '@/layouts';

// import store from '../store';

Vue.use(Router);

// 基础路由
const basicRoutes = [{
		path: '*',
		redirect: '/404',
		hidden: true
	},
	{
		path: '/404',
		component: () => import('@/views/exception/404')
	},
]

const serviceRoutes = [{
	path: '/',
	component: BasicLayout,
	redirect: '',
	hidden: true,
	children: [{
		path: '/',
		name: 'home',
		component: () => import('@/views/Home'),
		meta: {
			title: '首页',
			auth: false
		}
	}, {
		path: '/file',
		name: 'file',
		component: () => import('@/views/news/list'),
		meta: {
			title: '最新政策',
			auth: false
		}
	}, {
		path: '/declare',
		name: 'declare',
		component: () => import('@/views/news/list'),
		meta: {
			title: '项目申报',
			auth: false
		}
	}, {
		path: '/read',
		name: 'read',
		component: () => import('@/views/news/list'),
		meta: {
			title: '政策解读',
			auth: false
		}
	}, {
		path: '/diagram',
		name: 'diagramList',
		component: () => import('@/views/news/diagramList'),
		meta: {
			title: '政策图解',
			auth: false
		}
	}, {
		path: '/file/:id',
		name: 'fileDetail',
		component: () => import('@/views/news/detail'),
		meta: {
			title: '政策详情',
			auth: false
		}
	}, {
		path: '/declare/:id',
		name: 'declareDetail',
		component: () => import('@/views/news/detail'),
		meta: {
			title: '政策详情',
			auth: false
		}
	}, {
		path: '/read/:id',
		name: 'readDetail',
		component: () => import('@/views/news/detail'),
		meta: {
			title: '政策详情',
			auth: false
		}
	}, {
		path: '/diagram/:id',
		name: 'diagramDetail',
		component: () => import('@/views/news/detail'),
		meta: {
			title: '政策详情',
			auth: false
		}
	}, {
		path: '/login',
		name: 'login',
		component: () => import('@/views/login/login'),
		meta: {
			title: '登录',
			auth: false
		}
	}]
}]

// 防止路由重复点击
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

const routes = basicRoutes.concat(serviceRoutes);
const router = new Router({
	mode: 'history',
	routes,
	scrollBehavior(to) {
		if (to.hash) {
			return {
				selector: to.hash,
				behavior: 'smooth'
			};
		} else {
			return {
				y: 0
			};
		}
	}
})


// 挂载前置路由导航守卫
router.beforeEach((to, from, next) => {
	// 对需要记录滚动条的路由进行处理
	if (from.meta.keepScroll) {
		from.meta.scrollTop = window.scrollY
	}
	//验证是否已获得授权
	if (localStorage.getItem('access_token')) {
		if (to.path === '/signin') {
			next('/')
		}
		next()
	}
	if (to.meta.auth) {
		next('/signin')
	}
	next()
})

// 挂载后置路由导航守卫
router.afterEach((to) => {
	if (to.meta.title) {
		document.title = to.meta.title + '-' + setting.title
	}
})

// 导出路由
export default router